import React from 'react';
import InputMaskBase, { Props as BaseInputMaskProps } from 'react-input-mask';
import { Input, Props as InputProps } from './Input';

export interface Props extends Omit<BaseInputMaskProps, 'css'>, InputProps {}

export const InputMask = React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  const {
    mask,
    maskPlaceholder,
    alwaysShowMask,
    beforeMaskedStateChange,
    // START https://github.com/sanniassin/react-input-mask#usage
    value,
    onChange,
    disabled,
    onFocus,
    onBlur,
    onMouseDown,
    readOnly,
    // END https://github.com/sanniassin/react-input-mask#usage
    ...rest
  } = props;

  return (
    <InputMaskBase
      mask={mask}
      maskPlaceholder={maskPlaceholder || null}
      alwaysShowMask={alwaysShowMask}
      beforeMaskedStateChange={beforeMaskedStateChange}
      value={value}
      onChange={onChange}
      disabled={disabled}
      onFocus={onFocus}
      onBlur={onBlur}
      onMouseDown={onMouseDown}
      readOnly={readOnly}
    >
      <Input ref={ref} {...rest} />
    </InputMaskBase>
  );
});
